import { render, staticRenderFns } from "./MoleculeEditionProductSatellitesIncludedList.vue?vue&type=template&id=e8c4bbb8&"
import script from "./MoleculeEditionProductSatellitesIncludedList.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductSatellitesIncludedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports